var navbarData = {
    section_1:"Home",
    section_2:"About",
    section_3:"Skills",
    section_4:"Projects",
    section_5:"Resume",
}

exports.navbarData = navbarData